import { Popover } from "antd";

const Attire = ({ value }) => {
  return value ? (
    <Popover
      placement="right"
      content={
        <span className="text-grayBlack text-xs font-medium">
          {value}
        </span>
      }
      overlayClassName="event-shift-popover"
    >
      <p className="text-grayBlack text-xs font-medium w-fit line-clamp-4">
        {value}
      </p>
    </Popover>
  ) : (
    <p className="text-grayBlack text-[13px] font-medium w-fit">N/A</p>
  );
};

export default Attire;
